// Helper functions for Square API interactions

// Parses errors from Square API calls
export const parseSquareError = (error) => {
  if (error.details && error.details.errors) {
    const squareError = error.details.errors[0];
    switch (squareError.code) {
      case "CARD_DECLINED":
        return "Card declined due to insufficient funds or other issue.";
      case "INVALID_CARD":
        return "Invalid card details provided.";
      case "NO_CARD_ON_FILE":
        return "We do not have a card on file to charge.";
      case "SERVICE_UNAVAILABLE":
        return "Payment system is currently unavailable. Please try again later.";
      default:
        return squareError.detail || "An unexpected error occurred.";
    }
  }
  return error.message || "An unexpected error occurred.";
};